import { Injectable } from '@angular/core';
import { MessageType } from '../models/sms';
import { CourierRepo } from '../repositories/courier.repo';
import { ToastPosition, ToastService } from './toast.service';
import { firstValueFrom } from 'rxjs';
import { buildMessageText } from '../utils/sms-builder';

@Injectable({
  providedIn: 'root'
})
export class SmsService {

  constructor(
    private courierRepo: CourierRepo,
    private toastService: ToastService,
  ) { }

  async sendText(
    orderId: string,
    telephoneNumber: string,
    message: MessageType,
    branchId: string,
    branchName: string,
    meta?: { etaMinutes?: number; address?: string }
  ): Promise<void> {
    if (this.hasNotificationBeenSent(orderId, message)) {
      this.toastService.showInfoToast('Je hebt dit bericht al gestuurd', ToastPosition.Top);
      return;
    }

    const text = buildMessageText(message, branchId, branchName, meta);

    try {
      await firstValueFrom(
        this.courierRepo.sendSmsMessage({
          orderId,
          phoneNumber: telephoneNumber,
          textMessage: text
        })
      );

      this.setNotificationSent(orderId, message);
      this.toastService.showSuccessToast('Het bericht is verstuurd', ToastPosition.Top);
    } catch (error) {
      console.error('SMS sending failed:', error);
      this.toastService.showErrorToast('Het versturen van het bericht is mislukt. Probeer opnieuw.', ToastPosition.Top);
    }
  }

  private hasNotificationBeenSent(orderId: string, messageType: MessageType): boolean {
    return !!localStorage.getItem(`sms:${orderId}-${messageType}`);
  }

  private setNotificationSent(orderId: string, messageType: MessageType): void {
    localStorage.setItem(`sms:${orderId}-${messageType}`, 'sent');
  }
}
